import { Loader2 } from 'lucide-react';

/** Centered spinner for route-level loading / auth hydration. */
export function FullscreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-label="Loading" />
    </div>
  );
}
